// extracted by mini-css-extract-plugin
export default {"signCheckbox":"signCheckbox-b53a","signButton":"signButton-5442","signButtonText":"signButtonText-d1ce"};